<template>
	<card outlined :style="{borderColor: props.active ? `${$config.public.colors.success} !important` : undefined}">
		<resource-list-item :title="(props.cancelCondition.refund_percentage ?? 0) + '% ' + $t('label.refund_of_paid_amount')" divided>

			<template v-if="props.active || props.inactive" #right>
				<chip v-if="props.active" color="success" x-small class="ml-8">{{ $t('label.active') }}</chip>
				<chip v-else-if="props.inactive" x-small class="ml-8">{{ $t('label.inactive') }}</chip>
			</template>

			<info-list x-small>
				<info-list-item v-if="props.cancelCondition.end_date && (!props.cancelCondition.start_date || $date(props.cancelCondition.start_date).isBefore())" :icon="false"
								:color="props.active ? 'success' : undefined"
								:text="$t('text.price.window_end', {end: $date(props.cancelCondition.end_date).formatDateTimeRange(true)})"/>
				<info-list-item v-else-if="props.cancelCondition.start_date && props.cancelCondition.end_date" :icon="false" :color="props.active ? 'success' : undefined" :text="$t('text.price.window', {
                    start: $date(props.cancelCondition.start_date).formatDateTimeRange(false),
                    end: $date(props.cancelCondition.end_date).formatDateTimeRange(true)
                })"/>
				<info-list-item v-else-if="props.cancelCondition.start_date" :icon="false" :color="props.active ? 'success' : undefined"
								:text="$t('text.price.window_start', {start: $date(props.cancelCondition.start_date).formatDateTimeRange(false)})"/>

			</info-list>

		</resource-list-item>
	</card>
</template>

<script setup lang="ts">
const props = defineProps<{
	cancelCondition: object,

	// Whether an active layout shall be displayed on the price
	active: boolean,

	// Whether an inactive layout shall be displayed on the price
	inactive: boolean,
}>();


</script>